const calcWidthsMinMax = _ref => {
  let {
    minSlideWidth,
    maxSlideWidth,
    gutter,
    width
  } = _ref;
  if (minSlideWidth > maxSlideWidth) {
    throw new Error('minSlideWidth cannot be greater maxSlideWidth');
  }
  const containerToSlideRatio = width / (minSlideWidth + gutter);
  const possibleSlides = Math.floor(containerToSlideRatio);
  const slideWidth = Math.min(width / possibleSlides, maxSlideWidth + gutter);
  return {
    containerWidth: width,
    slideWidth,
    maskWidth: possibleSlides === 0 ? minSlideWidth : possibleSlides * slideWidth
  };
};
const calcWidthsNumSlides = _ref2 => {
  let {
    slides,
    width
  } = _ref2;
  const slideWidth = Math.floor(width / slides);
  return {
    containerWidth: width,
    slideWidth,
    maskWidth: width
  };
};
const getNewWidths = (_ref3, containerRef) => {
  let {
    responsive,
    ...props
  } = _ref3;
  const {
    width
  } = containerRef.current.getBoundingClientRect();
  const {
    slides,
    ...responsiveResult
  } = responsive({
    width
  });
  if (!slides) {
    return calcWidthsMinMax({
      ...props,
      ...responsiveResult,
      width
    });
  }
  return calcWidthsNumSlides({
    slides,
    width
  });
};
export default getNewWidths;